import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Section"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("g", { opacity: "0.6" }, [
  /* @__PURE__ */ createElementVNode("path", {
    opacity: "0.6",
    d: "M1.58009 11.2049C1.07356 10.8954 1.07356 10.3935 1.58009 10.084L7.08304 6.72105C7.58957 6.4115 8.41082 6.4115 8.91735 6.72105L14.4203 10.084C14.9268 10.3935 14.9268 10.8954 14.4203 11.2049L8.91735 14.5678C8.41082 14.8774 7.58957 14.8774 7.08304 14.5678L1.58009 11.2049Z"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    opacity: "0.8",
    d: "M1.58009 8.56046C1.07356 8.25092 1.07356 7.74904 1.58009 7.43949L7.08304 4.07658C7.58957 3.76703 8.41082 3.76703 8.91735 4.07658L14.4203 7.43949C14.9268 7.74904 14.9268 8.25092 14.4203 8.56046L8.91735 11.9234C8.41082 12.2329 7.58957 12.2329 7.08304 11.9234L1.58009 8.56046Z"
  }),
  /* @__PURE__ */ createElementVNode("path", { d: "M1.58009 5.91605C1.07356 5.60651 1.07356 5.10463 1.58009 4.79508L7.08304 1.43217C7.58957 1.12263 8.41082 1.12263 8.91735 1.43217L14.4203 4.79508C14.9268 5.10463 14.9268 5.60651 14.4203 5.91605L8.91735 9.27896C8.41082 9.58851 7.58957 9.58851 7.08304 9.27896L1.58009 5.91605Z" })
], -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var section = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { section as default };
